var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("warning-step", {
        attrs: {
          title: "Exit without verifying?",
          description: "To do this later, you’ll need to start over.",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "account-verification__step__buttons-container" },
        [
          _c(
            "el-button",
            {
              staticClass:
                "account-verification__step__button account-verification__step__button-white",
              attrs: { plain: "", type: "primary" },
              on: { click: _vm.cancelClose },
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "account-verification__step__button",
              attrs: { type: "primary" },
              on: { click: _vm.exitFlow },
            },
            [_vm._v("\n      Exit the flow\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }